module.exports = __webpack_public_path__ + "img/2active.2f8fdf8f.png";